import {
    FETCH_SELLERS,
    FETCH_SELLER,
    EDIT_SELLER,
    FETCH_INTEGRADORES,
    FETCH_FACTURACIONES,
    FETCH_SELLERS_FILTER,
    FETCH_LIQUIDACIONES_LISTA_SELLERS,
    SET_FILTRO_SELLER,
    FETCH_PROVEEDORES_FILTER
} from '../actions/types';

const initialState = {
    sellers: [],
    seller: {},
    integradores: [],
    facturaciones: [],
    filteredSellers: [],
    lista_sellers_liquidaciones: [],
    filtro: {},
    filteredProveedores: []
}

export default function (state = initialState, action) {

    switch (action.type) {

        case SET_FILTRO_SELLER:
            return {
                ...state,
                filtro:action.payload
            };

        case FETCH_SELLERS:
            return {
                ...state,
                sellers: action.payload
            };

        case FETCH_SELLER:
            return {
                ...state,
                seller: action.payload
            };

        case EDIT_SELLER:
            return {
                ...state,
                seller: action.payload
            };

        case FETCH_INTEGRADORES:
            return {
                ...state,
                integradores: action.payload
            };

        case FETCH_FACTURACIONES:
            return {
                ...state,
                facturaciones: action.payload
            };

        case FETCH_SELLERS_FILTER:
            return{
                ...state,
                filteredSellers: action.payload
            }
        case FETCH_PROVEEDORES_FILTER:
            return {
                ...state,
                filteredProveedores: action.payload
            }

        case FETCH_LIQUIDACIONES_LISTA_SELLERS:
            return{
                ...state,
                lista_sellers_liquidaciones: action.payload
            }

        default: return state
    }
}